module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<div class="b-railway-carriers__item">\n	<span class="b-railway-carriers__item-city">' +
((__t = ( railwayCarrier.caption)) == null ? '' : __t) +
' (' +
((__t = ( railwayCarrier.uid )) == null ? '' : __t) +
')</span>\n</div>\n';

}
return __p
}